import {Component, Inject, OnInit} from '@angular/core';
import {ProgressBarMode} from '@angular/material/progress-bar';
import {GeneralService} from '../../services/general.service';
import {AuthService} from '../../services/auth.service';
import {MatSnackBar} from '@angular/material/snack-bar';
import {IcDataSkillService} from '../../services/ic-data.skill.service';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';


@Component({
    selector: 'add-remove-assignments-dialog',
    templateUrl: './add-remove-assignments-dialog.component.html',
    styleUrls: ['./add-remove-assignments-dialog.component.scss']
})

export class AddRemoveAssignmentsDialogComponent implements OnInit {
    showProgress = false;
    progressMode: ProgressBarMode = 'determinate';
    completeProgress = 0;
    currentProcessIndex = 0;
    totalProcessCount = 0;
    processingRecord: string;
    processRecords: any[] = [];
    processData: any;
    statusMessage: string;
    complete = '';
    message: string;
    proficiency: number;
    showProfSlider: boolean;
    private processAction: string;

    constructor(
        private dialogRef: MatDialogRef<AddRemoveAssignmentsDialogComponent>,
        public _icSkillData: IcDataSkillService,
        public genHttp: GeneralService,
        public auth: AuthService,
        private _matSnackBar: MatSnackBar,
        @Inject(MAT_DIALOG_DATA) public data: AddRemoveAssignmentsModel,
    ) {

    }

    ngOnInit(): void {
        this.processAction = this.data.processAction;
        this.processData = this.data.processData;
        this.showProfSlider = false;
        this.proficiency = 3;
        if (this.processAction === 'Add_Assignments') {
            this.showProfSlider = true;
            this.message =  'You are about to add Team Members to Skill';
        }
        if (this.processAction === 'Remove_Assignments') {
            this.message =  'You are about to Remove Team Members from Skill';
        }
        if (this.processAction === 'Add_&_Remove_Team_Assignments') {
            this.message =  'You are about to process ' + this.data.processData.teams.length + ' teams';
            this.showProfSlider = true;
         }
    }
    async removeAgentsFromSkill(): Promise<any> {
        this.showProgress = true;
        this.progressMode = 'determinate';
        this.processRecords = this.data.processData;
        this.totalProcessCount = this.processRecords.length;
        for (let idx = 0; idx < this.totalProcessCount; idx++) {
            const record = this.processRecords[idx];
            this.processingRecord = record.skillName;
            const agentsToRemove = record.assignments.map(data => ({agentId: data.agentId}));
            this.currentProcessIndex = idx;
            this.completeProgress = Math.round((idx + 1) * 100 / this.totalProcessCount);
            let createSuccess = false;
            await this._icSkillData.deleteSkillAgents(record.skillId, agentsToRemove).then(() => {
                createSuccess = true;
            })
                .catch((error) => {
                    this.complete = error.aac_error;
                    this.dialogRef.close(error);
                });
            if (!createSuccess) {
                return false;
            }
        }
        this._matSnackBar.open('Users Updated!', 'OK', {
            verticalPosition: 'top',
            duration: 5000
        });
        return true;
    }
    async addAgentsToSkill(): Promise<any> {
        this.showProgress = true;
        this.progressMode = 'determinate';
        this.processRecords = this.data.processData.skills;
        this.totalProcessCount = this.processRecords.length;
        for (let idx = 0; idx < this.totalProcessCount; idx++) {
            const record = this.processRecords[idx];
            this.processingRecord = record.skillName;
            this.currentProcessIndex = idx;
            this.completeProgress = Math.round((idx + 1) * 100 / this.totalProcessCount);
            const agentAssignments = this.data.processData.agents.map(data => ({agentId: String(data.agentId), isActive: true, proficiency: this.proficiency}));
            await this._icSkillData.addSkillAgents(record.skillId, agentAssignments);
            await this._icSkillData.updateSkillAgents(record.skillId, agentAssignments);
        }
        this._matSnackBar.open('Users Updated!', 'OK', {
            verticalPosition: 'top',
            duration: 5000
        });
        return true;
    }
    // addSkills: this.addSkillSelection.selected, removeSkills: this.removeSkillSelection.selected, teams: this.teamSelection.selected
    async addRemoveTeamsToSkill(): Promise<any> {
        this.showProgress = true;
        this.progressMode = 'determinate';
        const addSkills = this.data.processData.addSkills;
        const removeSkills = this.data.processData.removeSkills;
        const processTeams = this.data.processData.teams;
        this.totalProcessCount = (addSkills.length + removeSkills.length) * processTeams.length;
        for (const processTeam of processTeams) {

             for (const addSkill of addSkills) {
                 this.processingRecord = processTeam.teamName + '-' + addSkill.skillName;
                 this.currentProcessIndex += 1;
                 this.completeProgress = Math.round(this.currentProcessIndex * 100 / this.totalProcessCount);
                 const agentAssignments = processTeam.agentStates.map(data => ({agentId: String(data.agentId), isActive: true, proficiency: this.proficiency}));
                 await this._icSkillData.addSkillAgents(addSkill.skillId, agentAssignments);
                 await this._icSkillData.updateSkillAgents(addSkill.skillId, agentAssignments);
             }
             for (const remSkill of removeSkills) {
                 this.processingRecord = processTeam.teamName + '-' + remSkill.skillName;
                 this.currentProcessIndex += 1;
                 this.completeProgress = Math.round(this.currentProcessIndex * 100 / this.totalProcessCount);
                 const agentsToRemove = processTeam.agentStates.map(data => ({agentId: data.agentId}));
                 await this._icSkillData.deleteSkillAgents(remSkill.skillId, agentsToRemove);
             }
        }
        this._matSnackBar.open('Users Updated!', 'OK', {
            verticalPosition: 'top',
            duration: 5000
        });
        return true;
    }


    onDismiss(): void {
        this.dialogRef.close(false);
    }

    onConfirm(): void {
        if (this.processAction === 'Remove_Assignments') {
            // handles updating of User skills based on a give user's skills
            this.removeAgentsFromSkill().then((processResult) => {
                if (processResult) {
                    this.dialogRef.close(true);
                }
            });
        }
        if (this.processAction === 'Add_Assignments') {
            // handles updating of User skills based on a give user's skills
            this.addAgentsToSkill().then((processResult) => {
                if (processResult) {
                    this.dialogRef.close(true);
                }
            });
        }
        if (this.processAction === 'Add_&_Remove_Team_Assignments') {
            // handles updating of User skills based on a give user's skills
            this.addRemoveTeamsToSkill().then((processResult) => {
                if (processResult) {
                    this.dialogRef.close(true);
                }
            });
        }
    }
}

export class AddRemoveAssignmentsModel {
    constructor(
        public processData: any,
        public processAction: string,
    ) {

    }
}
